import { Ref, ref, watch } from "vue";
import { useStore } from "vuex";
import { RESET_APP_TIMEOUT } from "@/util/constants.ts";

export interface AppIdleApi {
  isIdle: Ref<boolean>;
}

export const key = Symbol("appIdle");

export default function createData(): AppIdleApi {
  const store = useStore();
  const isIdle = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  watch(
    () => store.getters["idleVue/isAppIdle"],
    () => {
      if (
        store.getters["idleVue/isAppIdle"] &&
        !import.meta.env.DEV &&
        !store.getters.getNoTouch
      ) {
        timer = setTimeout(() => {
          isIdle.value = true;
        }, RESET_APP_TIMEOUT);
      } else {
        if (timer !== undefined) {
          clearTimeout(timer);
        }
        timer = undefined;
        isIdle.value = false;
      }
    }
  );
  return {
    isIdle,
  };
}

export const defaultApi = {
  isIdle: ref(false),
};

export const storybookApi = {
  isIdle: ref(false),
};
